module.exports = __webpack_public_path__ + "static/media/ParkRidgeAnimal_Logo2.364a1df9.jpeg";